import React, { useState } from "react";
import denyTicket from "../../../../../controllers/booking/Ticket/denyTicket";
import { enqueueSnackbar } from "notistack";
import { Modal3 } from "../../../../../components/DIsplay/Modal/Modal3";
import TextInput from "../../../../../components/form/TextInput";
import Button1 from "../../../../../components/form/Button1";

function ManageOrderCancelTicketRequest({ modal, setModal, booking }) {
  const [deniedReason, setDeniedReason] = useState("");
  const [loading, setLoading] = useState(false);
  async function handleDeny() {
    const reqBody = {
      ticketQueueId: booking?._id,
      deniedReason,
    };
    const res = await denyTicket(reqBody).finally(() => setLoading(false));

    if (res.return) {
      enqueueSnackbar("Ticket request has been denied.", {
        variant: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }
  return (
    <div>
      <Modal3
        open={modal?.denyTicket}
        setOpen={(modalState) => setModal({ ...modal, denyTicket: modalState })}
        title={"Decline Ticket Request"}
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          {/* <h5>What's your reson?</h5> */}
          <TextInput
            label="Remark"
            multiline
            rows={5}
            placeholder={"e.g. Ticket not available"}
            value={deniedReason || ""}
            onChange={(ev) => setDeniedReason(ev.target.value)}
          />
          <div className="flex justify-end items-center gap-4">
            <div>
              <Button1
                variant="outlined"
                className="btn-outlined flex-1"
                onClick={() => setModal({ ...modal, denyTicket: false })}
              >
                Cancel
              </Button1>
            </div>
            <Button1 onClick={() => handleDeny()} loading={loading}>
              Decline Request
            </Button1>
          </div>
        </div>
      </Modal3>
    </div>
  );
}

export default ManageOrderCancelTicketRequest;
